"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = require("./modules/Constants");
var MAX_SEARCH_DEPTH = 20;
var INCOME_TARGET_TOLERANCE = 0.05;
var HIGH_INVESTMENT_RETURN_GUESS = 0.1;
var UPPER_GUESS_PERCENTAGE_CONTINGENCY = 0.1;
var RunOutSolverResults = (function () {
    function RunOutSolverResults() {
    }
    return RunOutSolverResults;
}());
exports.RunOutSolverResults = RunOutSolverResults;
var RunOutSolver = (function () {
    function RunOutSolver(engine, inputs, targetRunOutAge) {
        this.engine = engine;
        this.inputs = inputs;
        this.targetRunOutAge = targetRunOutAge;
        this.baseTargetIncome = inputs.TargetIncome || 0;
    }
    RunOutSolver.setTargetIncomeForRunOut = function (engine, inputs, targetRunOutAge) {
        var result = new RunOutSolverResults();
        var solver = new RunOutSolver(engine, inputs, targetRunOutAge);
        if (solver.solve()) {
            result.targetIncome = solver.targetIncomeAtSmallestDifference;
        }
        else {
            result.targetIncome = solver.highestTargetIncomeForRunoutAboveTarget;
        }
        result.foundSolution = solver._foundSolution;
        return result;
    };
    RunOutSolver.prototype.solve = function () {
        var depth = 0;
        this._foundSolution = false;
        this._smallestDifference = Number.POSITIVE_INFINITY;
        this._highestTargetIncomeForRunoutAboveTarget = 0;
        var searchLowerBound = 0;
        var searchUpperBound = Math.floor(2 * this.guessUpperBound());
        while (depth++ < MAX_SEARCH_DEPTH && !this._foundSolution) {
            var midPoint = Math.floor((searchLowerBound + searchUpperBound) / 2);
            this.inputs.TargetIncome = midPoint;
            var output = this.engine.runSync(this.inputs);
            var difference = output.engineResults.subjectAgeOfFirstFailureToMeetTarget(midPoint, INCOME_TARGET_TOLERANCE) - this.targetRunOutAge - 1;
            if (difference > 0) {
                searchLowerBound = midPoint;
                if (depth === 1) {
                    break;
                }
            }
            else if (difference < 0) {
                searchUpperBound = midPoint;
            }
            else {
                this._foundSolution = true;
            }
            if (difference > 0) {
                this._highestTargetIncomeForRunoutAboveTarget = Math.max(this._highestTargetIncomeForRunoutAboveTarget, midPoint);
            }
            if (Math.abs(difference) < Math.abs(this._smallestDifference)) {
                this._targetIncomeAtSmallestDifference = midPoint;
                this._smallestDifference = difference;
            }
            if (searchUpperBound - searchLowerBound <= 1) {
                break;
            }
        }
        this.inputs.TargetIncome = this.baseTargetIncome;
        return this._foundSolution;
    };
    Object.defineProperty(RunOutSolver.prototype, "highestTargetIncomeForRunoutAboveTarget", {
        get: function () {
            return this._highestTargetIncomeForRunoutAboveTarget;
        },
        enumerable: true,
        configurable: true
    });
    RunOutSolver.prototype.guessUpperBound = function () {
        var output = this.engine.runSync(this.inputs);
        var subjectDeflatedBalanceAtRetirement = output.engineResults.subjectOutput.deflatedAssetsInYear[output.engineResults.get_subjectRetirementAgeIndex()];
        var partnerDeflatedBalanceAtRetirement = output.engineResults.partnerOutput.deflatedAssetsInYear[output.engineResults.get_partnerRetirementAgeIndex()];
        var yearsOfDrawing = this.targetRunOutAge - this.engine.params.getParamNumber("RetirementAge");
        var investmentReturnFactor = Math.pow(1 + HIGH_INVESTMENT_RETURN_GUESS, yearsOfDrawing);
        var maximumCombinedDeflatedBalance = subjectDeflatedBalanceAtRetirement + (output.engineResults.includePartner ? partnerDeflatedBalanceAtRetirement : 0);
        var agePensionComponent = this.engine.params.getParamNumber("PensionCouple") * 2 * Constants.FORTNIGHTS_PER_YEAR;
        var assetsComponent = investmentReturnFactor * maximumCombinedDeflatedBalance / yearsOfDrawing;
        var generousGuessAtMaximumFlatIncome = (1 + UPPER_GUESS_PERCENTAGE_CONTINGENCY) * (agePensionComponent + assetsComponent);
        return generousGuessAtMaximumFlatIncome;
    };
    Object.defineProperty(RunOutSolver.prototype, "foundSolution", {
        get: function () {
            return this._foundSolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunOutSolver.prototype, "smallestDifference", {
        get: function () {
            return this._smallestDifference;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RunOutSolver.prototype, "targetIncomeAtSmallestDifference", {
        get: function () {
            return this._targetIncomeAtSmallestDifference;
        },
        enumerable: true,
        configurable: true
    });
    return RunOutSolver;
}());
exports.RunOutSolver = RunOutSolver;
//# sourceMappingURL=RunOutSolver.js.map